import axios from 'axios'

let serviceUrl = ''
let serviceUrlV2 = ''
let serviceSignature = ''
var pathMultimediaUpload = ''

switch (process.env.GATSBY_ACTIVE_ENV) {
  case 'production':
    serviceUrl = '/v1'
    serviceUrlV2 = "https://thirdparty-origination-service.tysonprod.com/v1"
    serviceSignature = 'https://afi-bff-autburofirma-tyson-service.tysonprod.com/v1'
    pathMultimediaUpload = "https://afi-originacion-service.tysonprod.com/v1/multimedia/upload"
    break
  case 'qa':
  case 'staging':
  case 'test':
    //serviceUrl = process.env.GATSBY_BFF_URL ?? 'https://bff-origination-service.tysonbeta.com/v1'
    serviceUrl = "/v1"
    serviceUrlV2 = "https://thirdparty-origination-service.tysonbeta.com/v1"
    serviceSignature = 'https://afi-bff-autburofirma-tyson-service.tysonbeta.com/v1'
    pathMultimediaUpload = "https://afi-originacion-service.tysonbeta.com/v1/multimedia/upload"
    
    break
  default:
    // serviceUrl = 'https://bfflandingmicroservice20200924113820.azurewebsites.net/v4'
    // serviceUrl = 'https://afi-bff-origination-service.orquesta.calidad-architect.com/v1'
    // serviceUrl = 'https://afi-bff-origination-service.tysonbeta.com/v1'
    //serviceUrl =  process.env.GATSBY_BFF_URL ?? 'https://bff-origination-service.tysonbeta.com/v1'
    
    serviceUrl = "https://afi.tysonbeta.com/v1"
    serviceUrlV2 = "https://thirdparty-origination-service.tysonbeta.com/v1"
    //serviceUrl = process.env.GATSBY_ACTIVE_ENV==="dev" ? "https://afi.tysonbeta.com/v1" : "/v1"
    // serviceUrl = "https://afi-bff-origination-service.orquesta.calidad-architect.com/v1/" //==>
    serviceSignature = 'https://afi-bff-autburofirma-tyson-service.tysonbeta.com/v1'
    pathMultimediaUpload = "https://afi-originacion-service.tysonbeta.com/v1/multimedia/upload"
    // https://afi-bff-origination-service.tysonbeta.com/
}

export const urlBFF = serviceUrl

export const LandingV4Instance = axios.create({  
  baseURL: serviceUrl,
  timeout: 90000
})

export const LandingV4InstanceV2 = axios.create({  
  baseURL: serviceUrlV2,
  timeout: 90000
})

export const LandingV4InstanceSignature = axios.create({  
  baseURL: serviceSignature,
  timeout: 90000
})

export const LandingV4InstanceSignatureOriginacion = axios.create({  
  baseURL: pathMultimediaUpload,
  timeout: 90000
})
